import { SpendingTypeService } from 'app/core/services/spending-type.service';
import { PaymentDetailService } from './services/payment-detail.service';
import { VoucherMainService } from './services/voucher-main.service';
import { VoucherLedgerService } from './services/voucher-ledger.service';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule, Optional, SkipSelf } from '@angular/core';
import { AlertModule, BsDropdownModule, ProgressbarModule, TabsModule, TooltipModule } from 'ngx-bootstrap';
import { AuthenticationService } from '../+auth/+login/authentication.service';
import { BodyService } from '../shared/_utils/body.service';
import { LayoutService } from '../shared/layout/layout.service';
import { SoundService } from '../shared/sound/sound.service';
import { UserService } from '../shared/user/user.service';
import { VoiceControlService } from '../shared/voice-control/voice-control.service';
import { VoiceRecognitionService } from '../shared/voice-control/voice-recognition.service';
import { JsonApiService } from './api/json-api.service';
import { throwIfAlreadyLoaded } from './guards/module-import-guard';
import { GlobalErrorHandler } from './handlers/GlobalErrorHandler';
import { TokenInterceptor } from './handlers/TokenInterceptor';
import { AauditTrailEmployeeService } from './services/aaudit-trail-employee.service';
import { AauditTrailVoucherService } from './services/aaudit-trail-voucher.service';
import { AbsenceLeaveAttachService } from './services/absence-leave-attach.service';
import { AbsenceLeaveService } from './services/absence-leave.service';
import { AbsenceService } from './services/absence.service';
import { AfpService } from './services/afp.service';
import { AttendanceCardService } from './services/attendance-card.service';
import { BankService } from './services/bank.service';
import { CalendarEventService } from './services/calendar-event.service';
import { ContractTypeService } from './services/contract-type.service';
import { CostCenterDivisionService } from './services/cost-center-division.service';
import { CostCenterService } from './services/cost-center.service';
import { CountryService } from './services/country.service';
import { CurrencyTypeService } from './services/currency-type.service';
import { DeductionAfpService } from './services/deduction-afp.service';
import { DepartmentService } from './services/department.service';
import { DisabilityTypeService } from './services/disability-type.service';
import { DistrictService } from './services/district.service';
import { EducationTypeService } from './services/education-type.service';
import { EmployeeAreaService } from './services/employee-area.service';
import { EmployeeContractTypeService } from './services/employee-contract-type.service';
import { EmployeeContractService } from './services/employee-contract.service';
import { EmployeeFileService } from './services/employee-file.service';
import { EmployeeHomeService } from './services/employee-home.service';
import { EmployeeLawService } from './services/employee-law.service';
import { EmployeeLawsuitService } from './services/employee-lawsuit.service';
import { EmployeeManagerService } from './services/employee-manager.service';
import { EmployeeRelativeService } from './services/employee-relative.service';
import { EmployeeStatisticService } from './services/employee-statistic.service';
import { EmployeeTtypeService } from './services/employee-ttype.service';
import { EmployeeTypeService } from './services/employee-type.service';
import { EmployeeService } from './services/employee.service';
import { EmployerContributionService } from './services/employer-contribution.service';
import { EmploymentRegimeService } from './services/employment-regime.service';
import { EpsPlanService } from './services/eps-plan.service';
import { EpsService } from './services/eps.service';
import { EvaluationTypeService } from './services/evaluation-type.service';
import { EventService } from './services/event.service';
import { ExecutingUnitService } from './services/executing-unit.service';
import { ExpenseNatureService } from './services/expense-nature.service';
import { FiscalYearService } from './services/fiscal-year.service';
import { FormationTtypeService } from './services/formation-ttype.service';
import { FrequencyTypeService } from './services/frequency-type.service';
import { FundingSourceService } from './services/funding-source.service';
import { GeneralLedgerService } from './services/general-ledger.service';
import { HhelpdeskService } from './services/hhelpdesk.service';
import { HolidayService } from './services/holiday.service';
import { JobTitleService } from './services/job-title.service';
import { LaborLawService } from './services/labor-law.service';
import { LevelProgStructureService } from './services/level-prog-structure.service';
import { McppConceptService } from './services/mcpp-concept.service';
import { McppTypeService } from './services/mcpp-type.service';
import { MeasurementUnitService } from './services/measurement-unit.service';
import { MeritFaultService } from './services/merit-fault.service';
import { MpayrollConceptService } from './services/mpayroll-concept.service';
import { OccupationListService } from './services/occupation-list.service';
import { OccupationTtypeService } from './services/occupation-ttype.service';
import { OfficeTypeService } from './services/office-type.service';
import { OfficeService } from './services/office.service';
import { PayScaleService } from './services/pay-scale.service';
import { PaymentCategoryService } from './services/payment-category.service';
import { PaymentTypeService } from './services/payment-type.service';
import { PayrollConceptService } from './services/payroll-concept.service';
import { PayrollTypeService } from './services/payroll-type.service';
import { PensionTtypeService } from './services/pension-ttype.service';
import { PersonTypeService } from './services/person-type.service';
import { PlameAbsenceService } from './services/plame-absence.service';
import { PlameConceptService } from './services/plame-concept.service';
import { PlameTypeService } from './services/plame-type.service';
import { PlanningMetricService } from './services/planning-metric.service';
import { PoiBodyService } from './services/poi-body.service';
import { PoiHeadService } from './services/poi-head.service';
import { PreviousJobTitleService } from './services/previous-job-title.service';
import { PreviousWorkplaceService } from './services/previous-workplace.service';
import { ProgrammaticStructureService } from './services/programmatic-structure.service';
import { ProvinceService } from './services/province.service';
import { RelationshipTypeService } from './services/relationship-type.service';
import { RightholderDownService } from './services/rightholder-down.service';
import { ShiftService } from './services/shift.service';
import { ShiftingListService } from './services/shifting-list.service';
import { SnpDeductionService } from './services/snp-deduction.service';
import { SpecialtyService } from './services/specialty.service';
import { SpinnerService } from './services/spinner.service';
import { StudyCenterTypeService } from './services/study-center-type.service';
import { StudyCenterService } from './services/study-center.service';
import { SupportingDocumentService } from './services/supporting-document.service';
import { TerminationReasonService } from './services/termination-reason.service';
import { UbigeoService } from './services/ubigeo.service';
import { VendorService } from './services/vendor.service';
import { ViaTypeService } from './services/via-type.service';
import { WorkExperienceService } from './services/work-experience.service';
import { InterimManagerService } from './services/interim-manager.service';
import { EmployeeRecordService } from './services/employee-record.service';
import { AttendanceBodyService } from './services/attendance-body.service';
import { VacationHeadService } from './services/vacation-head.service';
import { EducationLevelService } from './services/education-level.service';
import { CopyTypeService } from './services/copy-type.service';
import { EmployeeEvaluationService } from './services/employee-evaluation.service';
import { EmployeeMeritFaultService } from './services/employee-merit-fault.service';
import { FiveYearService } from './services/five-year.service';
import { PayrollAmountService } from './services/payroll-amount.service';
import { ZoneTypeService } from './services/zone-type.service';
import { PayStubService } from './services/pay-stub.service';
import { EmployerAmountService } from './services/employer-amount.service';
import { EmployeePayrollService } from './services/employee-payroll.service';
import { ReportAbsenceLeaveDateService } from './services/report-absence-leave-date.service';
import { ReportAlphabeticalService } from './services/report-alphabetical.service';
import { VacationBodyService } from './services/vacation-body.service';
import { VacationDetailService } from './services/vacation-detail.service';
import { UsersService } from './services/user.service';
import { ArrayMenuService } from './services/array-menu.service';
import { ArrayEntryService } from './services/array-entry.service';
import { ReportCurrentEmployeeDataService } from './services/report-current-employee-data.service';
import { ReportAfpDeductionService } from './services/report-afp-deduction.service';
import { ReportConceptDetailService } from './services/report-concept-detail.service';
import { PayrollSummaryService } from './services/payroll-summary.service';
import { MhelpdeskService } from './services/mhelpdesk.service';
import { ReportEmployerContributionService } from './services/report-employer-contribution.service';
import { ReportPayrollRunSummaryService } from './services/report-payroll-run-summary.service';
import { AnnualIncomeService } from './services/annual-income.service';
import { DocumentTypeService } from './services/document-type.service';
import { VoucherBudgetService } from './services/voucher-budget.service';
import { VoucherReferenceService } from './services/voucher-reference.service';
import { IncomeNatureService } from './services/income-nature.service';
import { TupaService } from './services/tupa.service';
import { IncomeRuleService } from './services/income-rule.service';
import { IncomeOwnerService } from './services/income-owner.service';
import { IncomeUseService } from './services/income-use.service';
import { MemoTypeService } from './services/memo-type.service';
import { RegisterService } from './services/register.service';
import { RegisterDetailService } from './services/register-detail.service';
import { BankAccountService } from './services/bank-account.service';
import { IncomeMainService } from './services/income-main.service';
import { IncomeBudgetService } from './services/income-budget.service';
import { CurrencyRateService } from './services/currency-rate.service';
import { ReportWayToPayService } from './services/report-way-to-pay.service';
import { ReportDeductionsByEmployeeTypeService } from './services/report-deductions-by-employee-type.service';
import { ReportIncomeSummaryService } from './services/report-income-summary.service';
import { ReportSalesRecordService } from './services/report-sales-record.service';
import { ReportRPPMService } from './services/report-rppm.service';
import { UserMassiveLoadService } from './services/user-massive-load.service';
import { ReportVacationPeriodsService } from './services/report-vacation-periods.service';
import { ReportAttendanceSummaryService } from './services/report-attendance-summary.service';
import { ReportSummaryConceptService } from './services/report-summary-concept.service';
import { PayrollResultService } from './services/payroll-result.service';
import { PayrollResultDeleteService } from './services/payroll-result-delete.service';
import { ReportEpsEmployeeService } from './services/report-eps-employee.service';
import { ReportCertificate4thService } from './services/report-certificate-4th.service';
import { ReportEmployeeAnnualIncomeService } from './services/report-employee-annual-income.service';
import { FundingPhaseService } from './services/funding-phase.service';
import { FundingDetailService } from './services/funding-detail.service';
import { FundingMainService } from './services/funding-main.service';
import { AauditTrailFundingService } from './services/aaudit-trail-funding.service';
import { TranslationTextService } from './services/translation-text.service';
import { TranslationDetailService } from './services/translation-detail.service';
import { AcquisitionTypeService } from './services/acquistion-type.service';
import { RemoteWorkService } from './services/remote-work.service';
import { PaymentReferenceService } from './services/payment-reference.service';
import { EmployeeAttachService } from './services/employee-attach.service';
import { PettyCashMasterService } from './services/petty-cash-master.service';
import { PettyCashSummaryService } from './services/petty-cash-summary.service';
import { PettyCashAccountService } from './services/petty-cash-account.service';
import { PettyCashDetailService } from './services/petty-cash-detail.service';
import { PettyCashExpenseService } from './services/petty-cash-expense.service';
import { SpendingConceptService } from './services/spending-concept.service';
import { PlanningObjectiveService } from './services/planning-objective.services';
import { PettyCashReturnService } from './services/petty-cash-return.service';
import { ReportPettyCashService } from './services/report-petty-cash.service';
import { ContractParametersService } from './services/contract-parameters.service';
import { DataExtractionService } from './services/data-extraction.service';
import { BankStatementService } from './services/bank-statement.service';
import { ReportNepotismService } from './services/report-nepotism.service'; 
import { ReportSubLedgerService } from './services/report-sub-ledger.service';
import { ClockEntryService } from './services/clock-entry.service';
import { DeductionHoldService } from './services/deduction-hold.service';
import { ReportHighAndLowService } from './services/report-high-and-low.service';
import { ReportJobCertificateService } from './services/report-job-certificate.service';
import { AauditProcessService } from './services/aaudit-process.service';
import { InterfaceAirhspService } from './services/interface-airhsp.service';
import { AttachmentService } from './services/attachment.service';
import { TimesheetService } from './services/timesheet.service';
import { ContractGenerateService } from './services/contract-generate.service';
import { ReportAlphabetical2021Service } from './services/report-alphabetical2021.service';
import { AauditProcessHeadService } from './services/aaudit-process-head.service';
import { AauditProcessBodyService } from './services/aaudit-process-body.service';
import { InterfaceBankTransferService } from './services/interface-bank-transfer.service';
import { ReportPayConstancyService } from './services/report-pay-constancy.service';

@NgModule({
  imports: [
    CommonModule,
    TooltipModule.forRoot(),
    BsDropdownModule.forRoot(),
    ProgressbarModule.forRoot(),
    AlertModule.forRoot(),
    TabsModule.forRoot()
  ],
  exports: [
    HttpClientModule
  ],
  declarations: [],
  providers: [
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    JsonApiService,
    LayoutService,
    UserService,
    VoiceControlService,
    VoiceRecognitionService,
    SoundService,
    AuthenticationService,
    BodyService,
    FiscalYearService,
    FundingSourceService,
    CountryService,
    DepartmentService,
    ProvinceService,
    DistrictService,
    UbigeoService,
    CostCenterDivisionService,
    CostCenterService,
    ExecutingUnitService,
    LevelProgStructureService,
    ContractTypeService,
    ProgrammaticStructureService,
    LaborLawService,
    PaymentTypeService,
    SupportingDocumentService,
    FrequencyTypeService,
    PaymentCategoryService,
    JobTitleService,
    BankService,
    PersonTypeService,
    VendorService,
    GeneralLedgerService,
    ExpenseNatureService,
    EmployeeTypeService,
    AfpService,
    PlameTypeService,
    PlameConceptService,
    McppTypeService,
    McppConceptService,
    HhelpdeskService,
    EmployeeService,
    EmployerContributionService,
    EmployeeContractService,
    SpinnerService,
    EmployeeTtypeService,
    TerminationReasonService,
    OccupationTtypeService,
    FormationTtypeService,
    EmployeeContractTypeService,
    EmployeeAreaService,
    OfficeService,
    CurrencyTypeService,
    OccupationListService,
    OfficeTypeService,
    ShiftingListService,
    PlanningMetricService,
    EventService,
    MeasurementUnitService,
    PoiHeadService,
    PoiBodyService,
    DisabilityTypeService,
    EpsService,
    PayrollConceptService,
    PayScaleService,
    EmploymentRegimeService,
    EmployeeLawService,
    SnpDeductionService,
    PensionTtypeService,
    EpsPlanService,
    EmploymentRegimeService,
    EmployeeRelativeService,
    RelationshipTypeService,
    RightholderDownService,
    EmployeeHomeService,
    ZoneTypeService,
    ViaTypeService,
    EmployeeLawsuitService,
    ShiftService,
    AttendanceCardService,
    PlameAbsenceService,
    AbsenceService,
    EducationTypeService,
    MeritFaultService,
    EmployeeStatisticService,
    AauditTrailEmployeeService,
    AauditTrailVoucherService,
    HolidayService,
    SpecialtyService,
    PreviousJobTitleService,
    PreviousWorkplaceService,
    PayrollTypeService,
    MpayrollConceptService,
    EmployeeFileService,
    EmployeeManagerService,
    StudyCenterTypeService,
    CalendarEventService,
    AbsenceLeaveService,
    StudyCenterService,
    DeductionAfpService,
    WorkExperienceService,
    InterimManagerService,
    FiveYearService,
    EmployeeRecordService,
    EvaluationTypeService,
    AttendanceBodyService,
    VacationHeadService,
    EducationLevelService,
    CopyTypeService,
    EmployeeEvaluationService,
    EmployeeMeritFaultService,
    PayrollAmountService,
    AbsenceLeaveAttachService,
    PayStubService,
    EmployerAmountService,
    EmployeePayrollService,
    ReportAbsenceLeaveDateService,
    ReportAlphabeticalService,
    VacationBodyService,
    VacationDetailService,
    UsersService,
    ArrayMenuService,
    ArrayEntryService,
    ReportCurrentEmployeeDataService,
    ReportAfpDeductionService,
    ReportConceptDetailService,
    PayrollSummaryService,
    MhelpdeskService,
    ReportEmployerContributionService,
    ReportPayrollRunSummaryService,
    AnnualIncomeService,
    DocumentTypeService,
    ReportEmployerContributionService,
    VoucherBudgetService,
    VoucherLedgerService,
    VoucherMainService,
    VoucherReferenceService,
    PaymentDetailService,
    IncomeNatureService,
    TupaService,
    IncomeOwnerService,
    IncomeRuleService,
    IncomeUseService,
    MemoTypeService,
    RegisterDetailService,
    RegisterService,
    BankAccountService,
    IncomeMainService,
    IncomeBudgetService,
    CurrencyRateService,
    IncomeNatureService,
    ReportWayToPayService,
    ReportDeductionsByEmployeeTypeService,
    ReportIncomeSummaryService,
    ReportSalesRecordService,
    ReportRPPMService,
    UserMassiveLoadService,
    ReportVacationPeriodsService,
    ReportAttendanceSummaryService,
    ReportSummaryConceptService,
    PayrollResultService,
    PayrollResultDeleteService,
    ReportEpsEmployeeService,
    SpendingTypeService,
    ReportCertificate4thService,
    ReportEmployeeAnnualIncomeService,
    FundingPhaseService,
    FundingDetailService,
    FundingMainService,
    TranslationTextService,
    TranslationDetailService,
    RemoteWorkService,
    EmployeeAttachService,
    AcquisitionTypeService,
    RemoteWorkService,
    PaymentReferenceService,
    AauditTrailFundingService,
    PettyCashMasterService,
    PettyCashSummaryService,
    PettyCashAccountService,
    PettyCashDetailService,
    PettyCashExpenseService,
    SpendingConceptService,
    PlanningObjectiveService,
    PettyCashReturnService,
    ReportPettyCashService,
    ContractParametersService,
    DataExtractionService,
    BankStatementService,
    ReportNepotismService,
    ReportSubLedgerService,
    ClockEntryService,
    DeductionHoldService,
    ReportHighAndLowService,
    ReportJobCertificateService,
    AauditProcessService,
    InterfaceAirhspService,
    AttachmentService,
    TimesheetService,
    ContractGenerateService,
    ReportAlphabetical2021Service,
    AauditProcessHeadService,
    AauditProcessBodyService,
    InterfaceBankTransferService,
    ReportPayConstancyService,

  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts